import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FmcElementsComponent } from '../fmc-elements.component';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import _ from 'lodash';
import {NgFor, NgIf} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatListModule} from '@angular/material/list';
@Component({
  selector: 'fmc-abn-search',
  templateUrl: './abn-search.component.html',
  styleUrls: ['./abn-search.component.css'],
  standalone: true,
  imports: [
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class AbnSearchComponent extends FmcElementsComponent implements OnInit, OnChanges {
  public defaultControl = new UntypedFormControl();
  public defaultControlType = 'FormControl';
  public formGroup: UntypedFormGroup;
  public loadingResults = false;
  public selectedAbnAcnRecord: any;
  private hasSearched = false;
  @Input() mode = 'abn';
  @Input() disabled = false;
  @Output() public abnResults = new EventEmitter<any>();
  @Output() public clearAbnResults = new EventEmitter<any>();

  ngOnInit() {
    super.ngOnInit();
    // bind
    if (!this.formControl.validator && !this.validators) {
      this.formControl.setValidators([Validators.required]);
    }
    // create a result object to store state of selected ABN
    if (!this.formGroup.get(this.controlName + 'Result')) {
      this.formGroup.addControl(this.controlName + 'Result', new UntypedFormControl(null));
    } else {
      this.selectedAbnAcnRecord = JSON.parse(this.formGroup.get(this.controlName + 'Result').value);
    }

    // programmatically mark control to show mat-error as necessary
    if (this.formControl.value) {
      this.formControl.markAsTouched({ onlySelf: true });
    }

    // reactive form disabling
    this.setInputDisable();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.formControl) {
      this.setInputDisable();
    }
  }

  setInputDisable() {
    if (this.disabled) {
      this.selectedAbnAcnRecord = null;
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  searchAbnAcn() {
    if (this.formControl.value) {
      this.loadingResults = true;
      this.formControl.setErrors(this.formControl.errors ? this.formControl.errors : null);
      const query = this.formControl.value.toString().replace(/ /g, '');
      // console.log('ABN input:', query);

      // validate the format first
      if (!validateInputFormat(query, this.mode)) {
        this.loadingResults = false;
        this.openAbnDialog('');
        this.defaultControl.setErrors({ 'incorrect': true });
        return false;
      }
      // veda lookup
      this.lookupService.getOrgList(query)
        .subscribe(
          businesses => {
            console.log('[opening search results]');
            this.formControl.setErrors(null);
            this.loadingResults = false;
            if (this.mode === 'abn') {
              this.openAbnDialog(businesses.filter((business) => {
                if (typeof business['australian-business-number'] === 'undefined'
                  && typeof business['asic-bnr-report'] !== 'undefined'
                  && typeof business['asic-bnr-report']['business-name'] !== 'undefined'
                  && typeof business['asic-bnr-report']['business-name']['holder-reference'] !== 'undefined'
                  && typeof business['asic-bnr-report']['business-name']['holder-reference']['ABN'] !== 'undefined') {
                  business['australian-business-number'] = {};
                  // tslint:disable-next-line:max-line-length
                  business['australian-business-number']['_text'] = business['asic-bnr-report']['business-name']['holder-reference']['ABN']['_text'];
                }
                return business['match-name'] && business['australian-business-number'];
              }));
            } else {
              this.openAbnDialog(businesses.filter((business) => {
                if (typeof business['asic-report'] !== 'undefined'
                  && typeof business['asic-report']['asic-organisation-number'] !== 'undefined') {
                  business['australian-company-number'] = business['asic-report']['asic-organisation-number'];
                  return business['match-name'] && business['australian-company-number'];
                }
              }));
            }
          },
          error => {
            this.defaultControl.setErrors({ 'incorrect': true });
            this.loadingResults = false;
            console.log(error);
          });
    } else {
      this.formControl.markAsTouched({ onlySelf: true });
      // this.formGroup.controls['text'].setErrors({'incorrect': true});
    }
  }

  checkSearch() {
    console.log('checkSearch', this.hasSearched);
    const query = this.formControl.value.toString().replace(/ /g, '');
    if (!this.hasSearched && !validateInputFormat(query, this.mode)) {
      this.formControl.setErrors(this.formControl.errors ? { ...this.formControl.errors, incorrect: true } : { incorrect: true });
    } else {
      this.formControl.setErrors(this.formControl.errors ? this.formControl.errors : null);
    }

    if (this.formControl.value === '') {
      this.formControl.setErrors(null);
    }
  }

  clearSearch() {
    this.hasSearched = false;
    this.selectedAbnAcnRecord = null;
    this.formGroup.get(this.controlName + 'Result').patchValue(null);
    this.formControl.patchValue('');
    this.defaultControl.setErrors(null);
  }

  openAbnDialog(data): void {
    const dialogRef = this.dialog.open(AbnSearchDialogComponent, {
      width: '50%',
      data: {
        results: data,
        mode: this.mode
      }
    });

    if (data.length > 0) {
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        if (result) {
          this.hasSearched = true;
          this.selectedAbnAcnRecord = result;
          this.formGroup.get(this.controlName + 'Result').patchValue(JSON.stringify(result));
          if (this.mode === 'abn') {
            const abn = _.get(result, 'australian-business-number._text');
            this.formControl.patchValue(abn);
          }
          this.abnResults.next(result);
        } else {
          this.abnResults.next(null);
          this.formControl.setErrors({'incorrect': true});
        }
      });
    } else {
      // this.formControl.setErrors({'incorrect': true});
      // this.clearSearch();
    }
  }
}

function validateInputFormat(input, mode) {
  const charArr = input.split('');
  let isValid = false;
  let sum = 0;
  let weight = 0;

  if (charArr.length === 11 && mode === 'abn') {
    // validate an ABN
    weight = 1;
    // get sum of each digit * weight
    for (let i = 0; i < charArr.length; i++) {
      if (i === 0) {
        // on the first digit, subtract by 1
        // and multiply by 10
        sum = (charArr[i] - 1) * 10;
      } else {
        // succeding digit's weight starts at 1, with increments of 2
        sum += charArr[i] * weight;
        weight += 2;
      }
    }
    // check the remainder, 0 is valid
    if (sum % 89 === 0) {
      isValid = true;
    } else {
      isValid = false;
    }
  } else if (charArr.length === 9) {
    // validate an ACN
    weight = 8;
    for (let i = 0; i < charArr.length; i++) {
      // last digit is the check digit
      if (i === charArr.length - 1) {
        // get calculated complement
        // by getting the remainder of the sum divided by 10
        // then subtract the sum from 10
        let complement = 10 - (sum % 10);
        // if the calculated complement is 10, set it as 0
        if (complement === 10) {
          complement = 0;
        }
        // finally, compare the calculated complement to the last digit
        if (complement === Number(charArr[i])) {
          isValid = true;
        } else {
          isValid = false;
        }
      } else {
        // get sum of the first 8 digits
        sum += charArr[i] * weight;
        // weight starts at 8, decreasing by 1
        weight -= 1;
      }
    }
  }
  return isValid;
}

@Component({
  selector: 'fmc-abn-search-dialog',
  templateUrl: './abn-search-dialog.component.html',
  styleUrls: ['./abn-search.component.css'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatListModule,
    MatButtonModule,
    NgFor,
    NgIf
  ]
})
export class AbnSearchDialogComponent {
  constructor(public dialogRef: MatDialogRef<AbnSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  createdSupplierRecord(data) {
    this.dialogRef.close(data);
  }
}
